module.exports = __webpack_public_path__ + "img/slide8.ade678a2.png";